import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Card: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m659.41 584.41h-538.82v-388.82h474c35.74 0 64.82 29.08 64.82 64.82zm-510-28.82h481.18v-295.18c0-19.85-16.15-36-36-36h-445.18z' />
    <path d='m420 495h-210v-30h180c16.57 0 30 13.43 30 30z' />
    <path d='m360 405h-150v-30h120c16.57 0 30 13.43 30 30z' />
    <path d='m140 285h500v30h-500z' />
  </IconBase>
));

Card.displayName = 'Card';

export default Card;
